// extracted by mini-css-extract-plugin
export var logo = "_ja-2";
export var logoWrapper = "_ja-1";
export var strip = "_ja-0";